import React from 'react';
import HeaderOneLine from 'common/components/HeaderOneLine/HeaderOneLine';
import Loadable from 'common/libs/Loadable/Loadable';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';

const busHoldBookingSearchScreenTitle = 'Pesanan Belum Dibayar';

const BusReservationListSearch = Loadable({
  loader: () =>
    import(/* webpackChunkName: "BusReservationListSearch" */ 'modules/bus/transaction-list/components/BusReservationListSearch'),
  loading: DefaultLoadingScreen,
});

const BusReservationListSearchScreen = props => (
  <BusReservationListSearch {...props} />
);

BusReservationListSearchScreen.navigationOptions = {
  headerTitle: <HeaderOneLine title={busHoldBookingSearchScreenTitle} />,
};

export default BusReservationListSearchScreen;
